import { getCareSourceDisplayStatus } from './careSourceStatusModel';
import { isComplexDirectProfileKnowledgeSource } from './directProfileKnowledgeModel';

export const getCareSourceProfileChapterId = (source = {}) => (
  source.profileChapterId
  || source.sourceMetadata?.profileChapterId
  || source.metadata?.source?.profileChapterId
  || ''
);

export const shouldShowPendingProfileSourceForChapter = (source = {}, profileChapterId = '') => {
  const status = getCareSourceDisplayStatus(source).label;
  if (status === 'Processing' || status === 'Reading text' || status === 'Failed') {
    return getCareSourceProfileChapterId(source) === profileChapterId;
  }

  return isComplexDirectProfileKnowledgeSource(source)
    && getCareSourceProfileChapterId(source) === profileChapterId;
};
